/**
 * Bank Rules Routes
 *
 * URL patterns:
 *   /:organisation/banking/bank-rules                — list (master)
 *   /:organisation/banking/bank-rules/new            — create form (detail)
 *   /:organisation/banking/bank-rules/:id/edit       — edit form (detail)
 */

export default [
    {
        path: '/:organisation/banking/bank-rules',
        component: () => import('@/pages/[organisation]/banking/bank-rules.vue'),
        name: 'banking.bank-rules.index',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-rule.list-bank-rules',
        },
        children: [
            {
                path: 'new',
                component: () => import('@/pages/[organisation]/banking/bank-rules/new.vue'),
                name: 'banking.bank-rules.create-bank-rule',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-rule.create-bank-rule',
                },
            },
            {
                path: ':id/edit',
                component: () => import('@/pages/[organisation]/banking/bank-rules/[id]/edit.vue'),
                name: 'banking.bank-rules.update-bank-rule',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-rule.update-bank-rule',
                },
            },
        ],
    },
];
